<template>
  <div>

  </div>

</template>

<script>
  export default {
    name: "wechatLogin",
    data() {
      return {
        urlParams: this.$route.query

      }
    },
    created() {
      let urlParams = this.urlParams;
      if (urlParams.type === 'customer') {

      } else if (urlParams.type === 'user') {


      }

    },
    methods: {
      checkCode() {
        if (this.urlParams.code) {

        } else {
          let hrefUrl,
            state = (urlParams.url && urlParams.url !== 'undefined' ? urlParams.url : '');
          hrefUrl = ('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=' + state + '#wechat_redirect')
          location.href = hrefUrl
        }
      },


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/wechatLogin.vue